import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../shared/shared.module';
import { MaintenanceComponent } from './maintenance.component';
import { maintenanceRoute } from './maintenance.route';

@NgModule({
  imports: [JYoguiSharedModule, RouterModule.forChild([maintenanceRoute])],
  declarations: [MaintenanceComponent],
})
export class JYoguiMaintenanceModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/maintenance/maintenance.module.ts